export default "__VITE_ASSET__BsJ8W$PS__"